import React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';

import { Grid, Row, Col, ProgressBar, Button } from 'react-bootstrap';
import DeleteDocumentModal from './DeleteDocumentModal';
import PlayingAudioEffect from './PlayingAudioEffect';

import { getProgress, getDuration } from '../../../../utils/utils';
import { firebase } from '../../../../firebase';
import { default as config } from '../../../../constants/constants';
import { setPlaybackPlaylists } from '../../../../redux/actions/app-actions';

class Document extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPlayButton: false,
      showModal: false
    };
  }

  setShowPlayButtonState = (show) => {
    this.setState({ showPlayButton: show });
  };

  showModalHandler = (show) => {
    this.setState({ showModal: show });
  };

  playDocument = (document) => {
    this.setShowPlayButtonState(false);
    this.props.onPlayDocument(document);
    this.props.dispatch(
      setPlaybackPlaylists({ documents: this.props.playbackPlaylists })
    );
  };

  deleteDocumentHandler = () => {
    if (firebase.auth.currentUser) {
      // ...existing code...
    }
  };

  render() {
    // ...existing code...
    return null;
  }
}

export default connect()(Document);
